import API from "service";
import { logoutExpired } from "../Logout/Logout";
import { Role } from "utils";

export async function loginService(request) {
  const url = "open/onboarding/sign-in";
  const { data } = await API.post(url, request);
  return data;
}

export async function getInfoService() {
  try {
    const identifier = Role.getId();
    const { data } = await API.get(`secure/personal/profile/${identifier}`);
    return data;
    //
  } catch (error) {
    // If code === 6 the session has expired
    if (error?.response?.data?.code === 6) logoutExpired();
    throw error;
  }
}
// Check whether reset token is valid
export async function checkPasswordResetTokenService(token) {
  const { data } = await API.get(
    "open/onboarding/password/token-status",
    {
      params: { token },
    }
  );

  return data;
}

// Reset password
export async function resetPasswordService(request) {
  const { data } = await API.post(
    "open/onboarding/reset-password",
    request
  );

  return data;
}
// Forgot password
export async function forgotPasswordService(request) {
  const { data } = await API.post(
    "v2/open/onboarding/forgot",
    request
  );

  return data;
}
